import APIclient from "API/Client";

export const deactiveGoogleAuthenticator = () => {
  return APIclient.postData("/ms/b2b-auth/v1/2fa/disable2FA", {});
};
